import { useState, useEffect } from 'react';
import { formatNumber } from "src/MarketDataComponents/Helpers";
import { generateGuid } from 'src/Utils';

const rowMappings = [
    {
        title: 'Effective Maturity (Y)', 
        fieldName: 'effectiveMaturity'
    },
    {
        title: 'Effective Duration', 
        fieldName: 'modifiedDuration'
    },
    {
        title: 'Average Credit Quality', 
        fieldName: 'averageCreditQuality'
    }
];

export default function MaturityDist({setShowDist, maturityDistribution, maturityDistributionCategory, bondStatistics, bondStatisticsCategory, formattedDate}) {
    const [showTable, setShowTable] = useState(false);
    const [showTable2, setShowTable2] = useState(false);

    useEffect(() => {
        let showTable = false;
        let showTable2 = false;
        
        if (maturityDistribution && maturityDistribution.length) {
            maturityDistribution.map(dist => {
                if (dist.value && dist.label !== '') {
                    showTable = true;
                }
            });
    
            if (!maturityDistributionCategory.length) {
                maturityDistribution.map(dist => {
                    maturityDistributionCategory.push({label: dist.label, value: null});
                });
            }
        }

        rowMappings.map(row => {
            if (bondStatistics[row.fieldName]) {
                showTable2 = true;
            }
        });

        setShowDist(showTable || showTable2 ? true : false);
        setShowTable(showTable);
        setShowTable2(showTable2);
    }, []);

    const renderRows = () => {
        return maturityDistribution.map(dist => {
            return maturityDistributionCategory.map(cat => {
                if (dist.label === cat.label && dist.label !== '') {
                    return <tr key={generateGuid()}>
                        <td data-testid={`maturityDistLabel${dist.type}`}>{dist.label}</td>
                        <td className="text-align-right" data-testid={`maturityDistFundValue${dist.type}`}>{formatNumber(dist.value, 2)}</td>
                        <td className="text-align-right" data-testid={`maturityDistCatValue${dist.type}`}>{cat.value !== null ? formatNumber(cat.value, 2) : '-'}</td>
                    </tr>
                }
            })
        });
    }

    const renderRows2 = () => {
        return rowMappings.map(row => {
            return <tr key={generateGuid()}>
                <td data-testid={`${row.fieldName}Label`}>{row.title}</td>
                <td className="text-align-right" data-testid={`${row.fieldName}FundValue`}>{formatNumber(bondStatistics[row.fieldName], 2)}</td>
                <td className="text-align-right" data-testid={`${row.fieldName}CatValue`}>{formatNumber(bondStatisticsCategory[row.fieldName], 2)}</td>
            </tr>
        });
    }

    return <div className="card z-depth-0 margin-0">
        {showTable || showTable2 ? <div className="card-content padding-top-0 padding-right-0-sm padding-bottom-30-sm padding-left-0-sm">
            <div className="ajb-grid-row">
                <span className="card-title float-left float-none-sm" data-testid="maturityDistributionHeader">Maturity distribution %</span>
                {formattedDate ? <p className="h7 float-right float-none-sm" data-testid="maturityDistributionDate">{formattedDate}</p> : null}
            </div>
            {showTable ? <div className="ajb-grid-row">
                <table className="data-table data-table--small data-table--scroll margin-top-0 highlight">
                    <thead>
                        <tr>
                            <th></th>
                            <th className="text-align-right" data-testid="maturityDistributionFundTableHead1">Fund</th>
                            <th className="text-align-right" data-testid="maturityDistributionCatTableHead1">Category</th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderRows()}
                    </tbody>
                </table>
            </div> : null}
            {showTable2 ? <div className="ajb-grid-row">
                <table className="data-table data-table--small data-table--scroll margin-0 margin-top-30-sm highlight">
                    <thead>
                        <tr>
                            <th></th>
                            <th className="text-align-right" data-testid="maturityDistributionFundTableHead2">Fund</th>
                            <th className="text-align-right" data-testid="maturityDistributionCatTableHead2">Category</th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderRows2()}
                    </tbody>
                </table>
            </div> : null}
        </div> : null}
    </div>
}